import { MoreAboutMeState } from './State'
import { IResponseUpdateRequestPayload } from 'types'

export const SET_RESPONSE = 'moreAboutMeComponent.setResponse'
export const SET_RESPONSES = 'moreAboutMeComponent.setResponses'

export function setResponse(payload: IResponseUpdateRequestPayload) {
  return {
    type: SET_RESPONSE,
    payload
  } as const
}

export function setResponses(payload: MoreAboutMeState) {
  return {
    type: SET_RESPONSES,
    payload
  } as const
}

export type MoreAboutMeAction = ReturnType<typeof setResponse | typeof setResponses>
